import {
  type GenerateSearchSqlForStreamArgument,
  generateSearchSqlMustache,
  orderByLength,
  SEARCH_RESULT_LABEL_COLUMN_NAME,
  SEARCH_RESULT_VALUE_COLUMN_NAME,
} from './common.ts'

export function generateSearchSqlForZohoLayout({ model, parentModel }: GenerateSearchSqlForStreamArgument) {
  const nameProperty = model.properties.find((x) => x.meta === 'name') // Layoutのname
  const labelField = nameProperty?.name ?? 'id'
  const layoutModuleApiName = model.properties.find((x) => x.name === `module_api_name`)
  // eslint-disable-next-line sonarjs/todo-tag
  const objectName = parentModel.write?.sourceEntityName // TODO sourceで判定
  if (nameProperty === undefined || layoutModuleApiName === undefined || objectName === undefined) {
    return
  }

  const searchSql = `SELECT
layouts.id as ${SEARCH_RESULT_VALUE_COLUMN_NAME},
layouts."${labelField}" as ${SEARCH_RESULT_LABEL_COLUMN_NAME}
FROM "${model.name}" as layouts
WHERE ${generateSearchSqlMustache(`"${labelField}"`)}
AND layouts."${layoutModuleApiName.name}" = '${objectName}'
`
  return {
    sql: orderByLength(searchSql, `layouts."${labelField}"`),
    dependedPropertyNames: [
      {
        streamName: model.name,
        propertyName: nameProperty.name,
      },
      {
        streamName: model.name,
        propertyName: layoutModuleApiName.name,
      },
    ],
  }
}
